'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedtypes = require('nestedtypes');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

var _Market = require('./enums/Market');

var _Market2 = _interopRequireDefault(_Market);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modelDescription = {
  ticker: String.value(null),
  overnightPositionsSignedQty: Number.value(null),
  realizedGrossPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
  unrealizedPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
  bpUsed: _nestedHateoasCommonModels.MoneyModel.value(null),
  executedQty: Number.value(null),
  brokerFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  ecnFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  clearingFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  nsccFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  secFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  nyseFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  nsdqFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  exchangeFee: _nestedHateoasCommonModels.MoneyModel.value(null),
  totalFees: _nestedHateoasCommonModels.MoneyModel.value(null),
  realizedNetPnL: _nestedHateoasCommonModels.MoneyModel.value(null),
  totalNetPnL: _nestedHateoasCommonModels.MoneyModel.value(null)
};

function SummaryByTickerReport(domainBuilder) {
  domainBuilder.defineModel('SummaryByTickerReport', 'summaryByTickerReports', function (model) {
    model.define({
      defaults: modelDescription
    }).defineSearchMethod({
      name: 'findByAdmin',
      overrideUrl: 'api/admin/summariesByTicker',
      query: _nestedtypes.Model.extend({
        defaults: {
          user: String.value(null),
          range: [Date.value(null), Date.value(null)],
          market: _Market2.default.factory.value(null)
        },
        getQueryPart: function getQueryPart() {
          var searchParameters = {};
          if (this.user) {
            searchParameters.users = [this.user];
          }
          if (this.range[0]) {
            searchParameters.from = (0, _moment2.default)(this.range[0]).format('YYYY-MM-DD');
          }
          if (this.range[1]) {
            searchParameters.to = (0, _moment2.default)(this.range[1]).format('YYYY-MM-DD');
          }
          if (this.market) {
            searchParameters.market = this.market.name;
          }
          return (0, _nestedHateoas.hash2query)(searchParameters);
        }
      }),
      additionalInfo: _nestedtypes.Model.extend({
        defaults: {
          summary: _nestedtypes.Model.extend({
            defaults: modelDescription
          })
        }
      }),
      navigation: { sort: [{ property: 'ticker', direction: 'asc' }] }
    });
  });
}

exports.default = SummaryByTickerReport;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/SummaryByTickerReport.js
// module id = 1432
// module chunks = 118